import { OrganizationDetailLayout } from '@/pages/Organizations/OrganizationDetailLayout';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/organizations/$organizationId')({
  component: OrganizationDetailLayout,
  loader: () => ({ crumb: 'Organization' }),
});
